import { create } from "domain";
import { map } from "rxjs/operators";

let websiteInstance = window["MAIN_INSTANCE_PATHS"]?.instance;

export function handleTemplateNormalizer(elToNormalize = null) {
  elToNormalize = elToNormalize || document;

  if (elToNormalize?.querySelector("footer")) {
    elToNormalize.querySelector("footer").style.position = "relative";
  }

  if (!["acvet", "bairrolatino"].includes(websiteInstance)) {
    if (elToNormalize?.querySelectorAll(".slick-track")?.length > 0) {
      elToNormalize?.querySelectorAll(".slick-track")?.forEach((track) => {
        track["style"].width = 1500 + "px";
        track["style"].transform = "translate3d(-300px, 0px, 0px);";
      });
    }

    if (elToNormalize?.querySelectorAll(".slick-slide")?.length > 0) {
      elToNormalize?.querySelectorAll(".slick-slide")?.forEach((slide) => {
        slide["style"].width = 300 + "px";
      });
    }
  } else {
    console.log("None of them instances");
    if (elToNormalize?.querySelectorAll(".slick-track")?.length > 0) {
      elToNormalize?.querySelectorAll(".slick-track")?.forEach((track) => {
        track["style"].width = "100%";
        // track["style"].transform = "translate3d(-300px, 0px, 0px);";
      });
    }

    if (elToNormalize?.querySelectorAll(".slick-slide")?.length > 0) {
      elToNormalize?.querySelectorAll(".slick-slide")?.forEach((slide) => {
        slide["style"].width = "100%";
      });
    }
  }

  if (elToNormalize.querySelector(".slider__prev")) {
    elToNormalize.querySelectorAll(".slider__prev").forEach((b) => b.click());
  }

  if (elToNormalize?.querySelectorAll('[data-animate="fadeInDown"]')?.length > 0) {
    elToNormalize?.querySelectorAll('[data-animate="fadeInDown"]')?.forEach((el) => {
      el?.classList?.add("animated");
      el?.classList?.add("fadeInDown");
    });
  }

  if (elToNormalize?.querySelectorAll('[data-animate="fadeInUp"]')?.length > 0) {
    elToNormalize?.querySelectorAll('[data-animate="fadeInUp"]')?.forEach((el) => {
      el?.classList?.add("animated");
      el?.classList?.add("fadeInUp");
    });
  }

  if (elToNormalize?.querySelectorAll(".breadcrumb-item.theme-category-parent-breadcrumbs")?.length > 0) {
    elToNormalize?.querySelectorAll(".breadcrumb-item.theme-category-parent-breadcrumbs")?.forEach((el) => {
      el?.classList?.add("d-none");
    });
  }

  if (elToNormalize?.querySelector("header")) {
    let headerMenu = elToNormalize.querySelector("header");
    if (headerMenu.querySelectorAll("li")?.length > 0) {
      headerMenu.querySelectorAll("li")?.forEach((li) => {
        if (li?.className?.includes("menu-item-has-children") && li?.querySelector("ul") && li?.querySelector("ul").children.length === 0) {
          li.className = "";
          li.querySelector("ul").remove();
        }
      });
    }
  }

  if (elToNormalize?.querySelector("header")?.querySelector("ul")?.querySelectorAll('li[class="nav-item"]')?.length > 0) {
    elToNormalize
      ?.querySelector("header")
      ?.querySelector("ul")
      ?.querySelectorAll('li[class="nav-item"]')
      ?.forEach((el) => {
        if (el?.querySelectorAll("ul")?.length > 0) {
          el?.querySelectorAll("ul")?.forEach((ul) => {
            if (ul?.children?.length === 0) {
              ul?.remove();
              el?.querySelector("i")?.remove();
              el?.querySelector("div")?.remove();
              el?.querySelector(".caret")?.remove();
              el?.querySelector(".sub-menu")?.remove();
            }
          });
        }
      });
  }

  if (elToNormalize?.querySelector(".partners")) {
    const partnersDiv = elToNormalize.querySelector(".partners");

    const partnersData = [];
    if (partnersDiv) {
      partnersDiv.querySelectorAll(".partners-slide a").forEach((anchor) => {
        const url = anchor["href"];
        const img = anchor.querySelector("img");

        if (img) {
          partnersData.push({
            url: url,
            image: img.src,
            alt: img.alt,
          });
        }
      });
    }

    let containerSlider = document.createElement("div");
    containerSlider.style.width = "100%";
    containerSlider.style.display = "flex";
    containerSlider.style.flexDirection = "row";
    // containerSlider.style.overflowY = "hidden";
    // containerSlider.style.overflowX = "auto";
    containerSlider.style.overflow = "hidden";
    containerSlider.style.scrollBehavior = "smooth";
    containerSlider.style.scrollSnapType = "x mandatory";
    containerSlider.style.whiteSpace = "nowrap";
    containerSlider.style.gap = "100px";
    containerSlider.style.cursor = "grab";
    containerSlider.style.userSelect = "none"; // Prevents text/image selection

    partnersData.forEach((partner) => {
      const slideItem = document.createElement("a");
      slideItem.style.minWidth = "150px";
      slideItem.style.display = "flex";
      slideItem.style.justifyContent = "center";
      slideItem.style.alignItems = "center";
      slideItem.style.scrollSnapAlign = "center";
      slideItem.href = partner.url;
      slideItem.style.userSelect = "none"; // Prevent selection of links

      const img = document.createElement("img");
      img.src = partner.image;
      img.alt = partner.alt;
      img.loading = "lazy";
      img.style.width = "100%";
      img.style.height = "auto";
      img.style.maxWidth = "450px";
      img.style.objectFit = "contain";
      img.style.userSelect = "none"; // Prevents image selection

      slideItem.appendChild(img);
      containerSlider.appendChild(slideItem);
    });

    // Create navigation buttons
    const prevButton = document.createElement("button");
    prevButton.innerText = "◀";
    prevButton.style.position = "absolute";
    prevButton.style.left = "10px";
    prevButton.style.top = "50%";
    prevButton.style.transform = "translateY(-50%)";
    prevButton.style.zIndex = "1000";
    prevButton.style.cursor = "pointer";
    prevButton.style.backgroundColor = "white";
    prevButton.style.borderRadius = "500px";
    prevButton.style.width = "25px";
    prevButton.style.height = "25px";
    prevButton.style.border = "none";
    prevButton.style.alignContent = "center";
    prevButton.style.alignItems = "center";
    prevButton.style.display = "flex";
    prevButton.style.userSelect = "none"; // Prevents button selection

    const nextButton = document.createElement("button");
    nextButton.innerText = "▶";
    nextButton.style.position = "absolute";
    nextButton.style.right = "10px";
    nextButton.style.top = "50%";
    nextButton.style.transform = "translateY(-50%)";
    nextButton.style.zIndex = "1000";
    nextButton.style.cursor = "pointer";
    nextButton.style.backgroundColor = "white";
    nextButton.style.borderRadius = "500px";
    nextButton.style.width = "25px";
    nextButton.style.height = "25px";
    nextButton.style.border = "none";
    nextButton.style.alignContent = "center";
    nextButton.style.alignItems = "center";
    nextButton.style.display = "flex";
    nextButton.style.userSelect = "none"; // Prevents button selection

    // Add event listeners for navigation
    prevButton.addEventListener("click", () => {
      containerSlider.scrollLeft -= 480;
    });

    nextButton.addEventListener("click", () => {
      containerSlider.scrollLeft += 480;
    });

    // Draggable scrolling functionality
    let isDown = false;
    let startX;
    let scrollLeft;

    containerSlider.addEventListener("mousedown", (e) => {
      isDown = true;
      containerSlider.style.cursor = "grabbing";
      startX = e.pageX - containerSlider.offsetLeft;
      scrollLeft = containerSlider.scrollLeft;
      e.preventDefault(); // Prevent text/image selection
    });

    containerSlider.addEventListener("mouseleave", () => {
      isDown = false;
      containerSlider.style.cursor = "grab";
    });

    containerSlider.addEventListener("mouseup", () => {
      isDown = false;
      containerSlider.style.cursor = "grab";
    });

    containerSlider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault(); // Prevents text/image selection while dragging
      const x = e.pageX - containerSlider.offsetLeft;
      const walk = (x - startX) * 2; // Adjust speed
      containerSlider.scrollLeft = scrollLeft - walk;
    });

    // Prevent text selection globally while dragging
    containerSlider.addEventListener("dragstart", (e) => {
      e.preventDefault();
    });

    // Append elements to the main container
    const sliderWrapper = document.createElement("div");
    sliderWrapper.style.position = "relative";
    sliderWrapper.style.width = "100%";
    sliderWrapper.appendChild(containerSlider);
    sliderWrapper.appendChild(prevButton);
    sliderWrapper.appendChild(nextButton);

    elToNormalize.querySelector(".partners").innerHTML = "";
    elToNormalize.querySelector(".partners").appendChild(sliderWrapper);
  }

  // if (elToNormalize?.querySelectorAll('a[href*="/set-locale/"].dropdown-item')?.length > 0) {
  //   let allLangSelectors = elToNormalize.querySelectorAll('a[href*="/set-locale/"].dropdown-item');
  // }

  if (elToNormalize?.querySelector(".product-images")?.querySelector(".slider-for")) {
    let oldSlider = elToNormalize.querySelector(".product-images");
    oldSlider = oldSlider.querySelector(".slider-for");
    let imagesSlider = oldSlider.querySelectorAll("img");
    imagesSlider = Array.from(imagesSlider).map((el) => el["src"]);

    elToNormalize.querySelector(".product-images").innerHTML = "";
    let createMainDisplay = document.createElement("div");
    createMainDisplay.classList.add("col-9");

    let placeholderImage = document.createElement("img");
    placeholderImage["src"] = imagesSlider[0];
    placeholderImage["style"]["width"] = "100%";
    placeholderImage["style"]["height"] = "auto";

    createMainDisplay.appendChild(placeholderImage);

    let createLateralMenu = document.createElement("div");
    createLateralMenu.classList.add("col-3");
    createLateralMenu.classList.add("d-flex", "flex-column");
    createLateralMenu.style.maxHeight = "30%";
    createLateralMenu.style.overflowY = "auto";
    createLateralMenu.style.overflowX = "hidden";
    createLateralMenu.style.scrollbarWidth = "thin";
    createLateralMenu.style.scrollbarColor = "#000 #fff";
    createLateralMenu.style.scrollBehavior = "smooth";
    createLateralMenu.style["-webkit-overflow-scrolling"] = "touch";

    imagesSlider.forEach((item, ii) => {
      let createItem = document.createElement("img");
      createItem["src"] = item;
      createItem["style"]["width"] = "100%";
      createItem["style"]["height"] = "auto";

      if (ii === 0) {
        createItem["style"]["border"] = "1px solid #000";
      }

      createLateralMenu.appendChild(createItem);

      createItem.addEventListener("click", () => {
        createLateralMenu.querySelectorAll("img").forEach((el) => {
          el["style"]["border"] = "none";
        });
        placeholderImage["src"] = item;
        createItem["style"]["border"] = "1px solid #000";
      });
    });

    elToNormalize.querySelector(".product-images").appendChild(createLateralMenu);
    elToNormalize.querySelector(".product-images").appendChild(createMainDisplay);
  }

  if (true) {
    if (elToNormalize?.querySelector("#root")) {
      elToNormalize.querySelector("#root")["style"]["width"] = "100%";
    }

    if (elToNormalize?.querySelectorAll(".main-menu__item")?.length > 0) {
      elToNormalize.querySelectorAll(".main-menu__item").forEach((el) => {
        el.classList.remove("main-menu__item--has-child");
      });
    }

    if (elToNormalize?.querySelector("footer")) {
      elToNormalize.querySelector("footer")["style"]["marginLeft"] = "0px";
    }

    if (elToNormalize?.querySelectorAll("ol")?.length > 0) {
      elToNormalize?.querySelectorAll("ol")?.forEach((o) => {
        o.style.display = "flex";
        o.style.flexDirection = "column";
      });
    }

    if (elToNormalize?.querySelector(".testimonials-slider")) {
      const slider = elToNormalize.querySelector(".testimonials-slider")?.closest("section");
      const slides = slider?.querySelectorAll(".testimonials-slider__item");
      const prevButton = slider?.querySelector(".slider__prev");
      const nextButton = slider?.querySelector(".slider__next");

      console.log(slider, slides, prevButton, nextButton);

      let currentIndex = 0;
      let totalSlides = slides?.length;

      // Initial setup
      if (slider) {
        slider!["style"]!["display"] = "flex";
        slider!["style"]!["transition"] = "transform 0.5s ease-in-out";
      }

      if (slides && nextButton && prevButton) {
        nextButton.addEventListener("click", () => {
          slides[currentIndex]["style"]["flex"] = "0 0 0%";
          currentIndex = (currentIndex + 1) % totalSlides;
          slides[currentIndex]["style"]["flex"] = "0 0 100%";
        });
      }
    }
  }

  if (true) {
    if (elToNormalize?.querySelector('[class*="news-block-"]')) {
      elToNormalize.querySelectorAll('[class*="news-block-"]').forEach((el) => {
        el.querySelector(".inner-box").querySelector("img")["style"]["width"] = "25%";
      });
    }

    if (elToNormalize?.querySelector(".header-top")?.querySelector(".auto-container")) {
      elToNormalize.querySelectorAll(".header-top").forEach((ht) => {
        ht.querySelector(".auto-container")["style"]["display"] = "flex";
        ht.querySelector(".auto-container")["style"]["justify-content"] = "space-between";
        ht.querySelector(".auto-container")["style"]["align-items"] = "center";
        ht.querySelector(".auto-container")["style"]["width"] = "100%";
        ht.querySelector(".auto-container").classList.remove("clearfix");
        ht.querySelector(".auto-container")
          .querySelectorAll(".icon")
          .forEach((i) => {
            i["style"]["color"] = "#fff";
          });
      });
    }
  }

  if (true) {
    if (elToNormalize?.querySelector("#preloader")) {
      elToNormalize.querySelector("#preloader").remove();
    }
  }

  if (true) {
    if (elToNormalize?.querySelector(".blog__bg")) {
      // elToNormalize.querySelector(".blog__bg")["style"]["top"] = "10%";
      let timerCleanBlogBG = setInterval(() => {
        console.log("Not removed yet");
        if (elToNormalize?.querySelector(".blog__bg")) {
          console.log("Removing");
          elToNormalize.querySelector(".blog__bg").remove();
        } else {
          console.log("Removed");
          clearInterval(timerCleanBlogBG);
        }
      });
    }
  }
  //epmurca
  if (true) {
    if (elToNormalize?.querySelector(".main-menu")) {
      elToNormalize
        ?.querySelector(".main-menu")
        ?.querySelector("ul")
        ?.querySelectorAll("li")
        ?.forEach((el) => {
          if (!el?.querySelector("ul") || el?.querySelector("ul")?.children?.length === 0) {
            el?.classList?.remove("dropdown");
            el?.querySelector("ul")?.remove();
            el.querySelector("a")?.querySelector("i")?.remove();
          }
        });
    }

    if (elToNormalize?.querySelector(".slider-controls")) {
      elToNormalize
        ?.querySelector(".slider-controls")
        ?.querySelectorAll("button")
        ?.forEach((element, idx) => {
          element.querySelector("i")?.remove();
          element.style.paddingTop = "5px";
          if (idx === 0) {
            element.style.marginTop = "75px";
          } else {
            element.style.left = "5px";
          }
          console.log(element);
        });
    }
  }
}
